export const ONLINE_PAYMENT_STATUSES = [
  'pending',
  'succeeded',
  'failed',
  'cancelled',
  'needs_review',
] as const;

export type OnlinePaymentStatus = (typeof ONLINE_PAYMENT_STATUSES)[number];
export type OnlinePaymentResolutionType = 'refunded' | 'applied';

export interface OnlinePaymentResolution {
  type: OnlinePaymentResolutionType;
  note: string;
  refundRef: string | null;
  resolvedAt: string;
  resolvedBy: string | null;
}

export interface OnlinePaymentReview {
  paymentId: string;
  billId: string;
  billNumber: string;
  billStatus: 'open' | 'closed' | 'void';
  billBalanceSen: number;
  patient: { id: string; fullName: string };
  branch: { id: string; name: string };
  amountSen: number;
  currency: 'MYR';
  method: 'card' | 'e_wallet' | null;
  provider: string;
  providerRef: string;
  status: OnlinePaymentStatus;
  reviewReason: string | null;
  failureCode: string | null;
  needsAction: boolean;
  resolution: OnlinePaymentResolution | null;
  createdAt: string;
  completedAt: string | null;
}

export interface OnlinePaymentsQuery {
  status?: OnlinePaymentStatus;
  needsAction?: boolean;
  billId?: string;
  from?: string;
  to?: string;
  page: number;
  pageSize?: number;
}

export interface ResolveOnlinePaymentInput {
  paymentId: string;
  resolution: OnlinePaymentResolutionType;
  note: string;
  refundRef?: string;
}
